import backgroundDesk from "../../img/background.jpg";
import backgroundMob from "../../img/mob.jpg";

export { backgroundDesk, backgroundMob };

/** @deprecated Prefer backgroundDesk / backgroundMob */
export const deskMain = backgroundDesk;
/** @deprecated Prefer backgroundDesk / backgroundMob */
export const mobMain = backgroundMob;

export function isMobViewport() {
  const w = window.innerWidth;
  const narrow = w > 0 && w <= 768;
  const portrait =
    window.matchMedia &&
    window.matchMedia("(orientation: portrait)").matches;
  return narrow && portrait;
}

export function getBaseStageBackground(mob = isMobViewport()) {
  return mob ? backgroundMob : backgroundDesk;
}

/** Single full-bleed stage / app background (desk or mobile art). */
export function applyStageBodyBackground(
  body,
  {
    mob = isMobViewport(),
    fixedAttachment = false,
  } = {}
) {
  const url = getBaseStageBackground(mob);
  const attachment = fixedAttachment ? "fixed" : mob ? "scroll" : "fixed";
  const sizePriority = mob ? "important" : "";

  body.style.backgroundImage = `url("${url}")`;
  body.style.backgroundRepeat = "no-repeat";
  body.style.backgroundPosition = "center center";
  body.style.setProperty("background-size", "100% 100%", sizePriority);
  body.style.backgroundAttachment = attachment;
  body.style.backgroundColor = "#e8d9a8";
}

const APP_BODY_STYLE_KEYS = [
  "background-attachment",
  "background-size",
  "background-repeat",
  "background-position",
  "overflow-x",
  "margin",
  "padding",
  "height",
  "font-family",
];

/** Shared body background for login and similar app pages. */
export function setupAppPageBodyBackground(body) {
  const snapshot = APP_BODY_STYLE_KEYS.map((k) => [
    k,
    body.style.getPropertyValue(k),
  ]);

  body.style.setProperty("background-attachment", "fixed");
  body.style.setProperty("background-size", "100% 100%");
  body.style.setProperty("background-repeat", "no-repeat");
  body.style.setProperty("background-position", "center");
  body.style.setProperty("overflow-x", "hidden");
  body.style.setProperty("margin", "0");
  body.style.setProperty("padding", "0");
  body.style.setProperty("height", "100vh");
  body.style.setProperty(
    "font-family",
    "'FiraSans-Medium', sans-serif",
    "important"
  );

  const apply = () => {
    applyStageBodyBackground(body, {
      mob: isMobViewport(),
      fixedAttachment: true,
    });
  };

  apply();
  window.addEventListener("resize", apply);
  window.addEventListener("orientationchange", apply);

  return () => {
    window.removeEventListener("resize", apply);
    window.removeEventListener("orientationchange", apply);
    body.style.removeProperty("background-image");
    snapshot.forEach(([k, v]) => {
      if (v) body.style.setProperty(k, v);
      else body.style.removeProperty(k);
    });
  };
}
